import {BaseTransaction} from "../../../../../api/baseTransactions/BaseTransaction.ts";
import {InformationCircleIcon} from "@heroicons/react/24/outline/index";
import {GLAListBox} from "./GLAListBox.tsx";
import { GlAccount } from "../../../../../hooks/useGLAccounts.ts";

export function TransactionRow({transaction, glAccounts, onChangeFunc, onInfoClick, readOnly}: {
    transaction: BaseTransaction,
    glAccounts: GlAccount[],
    onChangeFunc: (newGlAccount: GlAccount, oldTransaction: BaseTransaction) => void,
    onInfoClick: (transaction: BaseTransaction) => void,
    readOnly: boolean
}) {
    return (
        <>
            <tr key={transaction.iban}>
                <td className='relative whitespace-nowrap py-4 pr-4 text-sm font-medium sm:pr-8 lg:pr-8 inline-flex gap-2 items-center text-xs'>
                    <span onClick={() => onInfoClick(transaction)}><InformationCircleIcon
                        className="w-6 h-6 cursor-pointer"/></span>{transaction.iban}
                </td>
                <td className='relative whitespace-nowrap py-4 pl-3 pr-4 text-sm font-medium sm:pr-8 lg:pr-8 max-w-48 whitespace-pre-wrap text-xs'>{transaction.counterParty}</td>
                <td className='relative whitespace-nowrap py-4 pl-3 pr-4 text-sm font-medium sm:pr-8 lg:pr-8 max-w-96 whitespace-pre-wrap text-xs'>{transaction.desc}</td>
                <td className='relative whitespace-nowrap py-4 pl-3 pr-4 text-sm font-medium sm:pr-8 lg:pr-8'>
                    {transaction.flow === "inflow" &&
                        <span className="text-green-600">+{transaction.amount / 100}</span>}
                    {transaction.flow === "outflow" &&
                        <span className="text-red-600">-{transaction.amount / 100}</span>}
                </td>
                <td className='relative whitespace-nowrap py-4 pl-3 pr-4 text-sm font-medium sm:pr-8 lg:pr-8 max-w-96 whitespace-pre-wrap flex items-start'>{transaction.date}</td>
                <td className="text-right">
                    {!readOnly &&
                        <GLAListBox
                            glAccounts={glAccounts}
                            value={transaction.generalLedgerAccountId ?? null}
                            onChangeFunc={(newGlAccount) => onChangeFunc(newGlAccount, transaction)}
                        />}
                    {readOnly &&
                        <span
                            className="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1  font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
                            <svg viewBox="0 0 6 6" aria-hidden="true"
                                 className={(transaction.flow === 'inflow') ? 'fill-green-500 h-1.5 w-1.5' : 'fill-red-500 h-1.5 w-1.5'}>
                                <circle r={3} cx={3} cy={3}/>
                            </svg>
                            {transaction.generalLedgerAccount.label_nl}
                        </span>
                    }

                </td>

            </tr>
        </>
    )
}
